import { useDraggable } from "@dnd-kit/core";
import React from "react";

export function clamp(min: number, v: number, max: number) {
    return Math.max(min, Math.min(max, v));
}

interface DraggableProps extends React.HTMLProps<HTMLDivElement> {
    name: string;
    disabled?: boolean;
}

export function Draggable(props: DraggableProps) {
    const { setNodeRef, transform, listeners } = useDraggable({
        id: props.name,
        disabled: props.disabled
    });
    const style = transform ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      } : undefined;
    console.log(style);
    return <div {...listeners} {...props} style={style} ref={setNodeRef} />
}
